import { search, star } from "@simplybusiness/icons";
import { Icon, Segment, SegmentGroup, Text } from "@simplybusiness/mobius";

export const SpecialistReferralContentWhileWaiting = () => (
  <div className="mobius-specialist-referral-content__while-waiting-section">
    <h2 className="mobius-specialist-referral-content__section-title">
      While you are waiting
    </h2>

    <div className="mobius-specialist-referral-content__sections">
      <section className="mobius-specialist-referral-content__while-waiting-box-1">
        <SegmentGroup>
          <Segment className="mobius-specialist-referral-content__section-body">
            <Icon
              icon={search}
              size="md"
              className="mobius-specialist-referral-content__waiting-icon"
              color="bubblegum"
            />
            <div>
              <Text variant="body">
                Our specialists will be exploring a wide range of insurance
                cover that is not available online
              </Text>
            </div>
          </Segment>
        </SegmentGroup>
      </section>

      <section className="mobius-specialist-referral-content__while-waiting-box-2">
        <SegmentGroup>
          <Segment className="mobius-specialist-referral-content__section-body">
            <Icon
              icon={star}
              size="md"
              className="mobius-specialist-referral-content__waiting-icon"
              color="bubblegum"
            />
            <div>
              <Text variant="body">
                Our insurance experts will get to know your business, ensuring
                we really understand your needs
              </Text>
            </div>
          </Segment>
        </SegmentGroup>
      </section>
    </div>
  </div>
);
